'use client'

import { useMemo } from 'react'
import { uniqBy } from 'lodash'

import { FilterModel } from '@marketplace-web/catalog/catalog-data'
import { initialFilterState } from '@marketplace-web/catalog/catalog-page-data'
import { useLatestCallback } from '@marketplace-web/shared/ui-state-util'

import useFetchCatalogBrand from './useFetchCatalogBrand'
import useGetSelectedStaticFilters from './useGetSelectedStaticFilters'
import useFetchDynamicFilters from './useFetchDynamicFilters'

const useFilterReset = () => {
  const fetchDynamicFilters = useFetchDynamicFilters()
  const fetchCatalogBrand = useFetchCatalogBrand()
  const { selectedStaticFilters } = useGetSelectedStaticFilters()

  const selectedStaticFiltersWithoutQuery = useMemo(() => {
    return uniqBy(selectedStaticFilters, 'name')
      .map(filter => filter.name)
      .filter(name => name !== 'query')
  }, [selectedStaticFilters])

  const resetFilters = useLatestCallback(() => {
    const filtersToReset = selectedStaticFiltersWithoutQuery.reduce<Partial<FilterModel>>(
      (params, filterName) => {
        if (filterName in initialFilterState) {
          return {
            ...params,
            [filterName as keyof FilterModel]: initialFilterState[filterName as keyof FilterModel],
          }
        }

        return params
      },
      {},
    )

    fetchDynamicFilters({
      selectedDynamicFilters: [],
      selectedFilters: filtersToReset,
    })
    fetchCatalogBrand({ selectedDynamicFilters: [] })
  })

  return { resetFilters, selectedStaticFiltersWithoutQuery }
}

export default useFilterReset
